const showForm = () => {
  const form = document.querySelector(".webinar-registration");
  const expiration = form.getAttribute("data-expiration");

  if (expiration === "" || Date.now() > new Date(expiration))
    form.classList.add("hide");
};

const getWebinarId = () => {
  const node = document.querySelector('input[name="webinar-id"]');
  const val = node.getAttribute("data-value");
  const splitVal = val.split("/");

  return splitVal[splitVal.length - 1];
};

const submitWebinarForm = () => {
  const joinForm = MktoForms2.getForm(1032);
  const form = document.forms["register-webinar"];
  const wrapper = document.querySelector(".webinar-registration");

  joinForm.onSuccess(function(values, followUpUrl) {
    wrapper.classList.add("confirmation");
    return false;
  });

  joinForm.setValues({
    FirstName: form["first-name"].value,
    LastName: form["last-name"].value,
    Email: form.email.value,
    Organization: form.organization.value,
    Title: form["job-title"].value,
    webinarProgramName: getWebinarId(),
  });

  joinForm.submit();
};

const addMarketoHandlers = () => {
  const form = document.forms["register-webinar"];

  form.addEventListener("submit", e => {
    e.preventDefault();
    const email = form.email.value;
    const emailValid = /@.*?\./.test(email);

    if (emailValid) {
      submitWebinarForm();
    } else {
      form.classList.add("email-error");
    }
  });
};

const init = () => {
  showForm();
  addMarketoHandlers();
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1032);
};

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/webinarDetails.js